/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlansQuery } from '../../models/get-plans-query';
import { GetPlansQueryResult } from '../../models/get-plans-query-result';

export interface ApiPlanGetPlansPost$Params {
  
    /**
     * Filters for retrieving plans
     */
    body?: GetPlansQuery
}

export function apiPlanGetPlansPost(http: HttpClient, rootUrl: string, params?: ApiPlanGetPlansPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetPlansPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlansQueryResult>;
    })
  );
}

apiPlanGetPlansPost.PATH = '/api/Plan/GetPlans';
